import CoursesPage from "../../features/dashboard/courses/CoursesPage";

function CoursesDB() {
  return <CoursesPage />;
}

export default CoursesDB;
